<template>
    <LoaderOverlay v-if="loading && !user" />
  <div v-else-if="user" class="page-content profile-content">
      <UserProfileForm
        :user="user"
        :loading="loading"
        :pending-avatar="pendingAvatar"
        @update-user="updateProfile"
      />
      <UserAvatar
        :avatar-name="user.avatarName"
        @avatar-selected="handleAvatarSelected"
      />
    </div>
    <EmptyState
      v-else
      error="Impossible de charger votre profil."
    />
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'
import UserAvatar from '@/components/UserAvatar.vue'
import UserProfileForm from '@/components/UserProfileForm.vue'
import LoaderOverlay from '@/components/LoaderOverlay.vue'
import EmptyState from '@/components/EmptyState.vue'
import { useUserStore } from '@/stores/userStore'

const userStore = useUserStore()
const { user, loading } = storeToRefs(userStore)
const pendingAvatar = ref(null)

onMounted(async () => {
  if (!user.value) {
    await userStore.fetchUser()
  }
})

const updateProfile = async (payload) => {
  console.log('Mise à jour du profil avec les données:', payload)
  try {
    if (pendingAvatar.value) {
      await userStore.updateAvatar(pendingAvatar.value)
      pendingAvatar.value = null
    }

    await userStore.updateUser(payload)
  } catch (err) {
    console.error('Erreurf lors de la mise à jour:', err)
  }
}

const handleAvatarSelected = (file) => {
  pendingAvatar.value = file
}
</script>

<style scoped>
.profile-content {
  flex-direction: row;
  align-items: flex-start;
  gap: 2rem;
}
:deep(.form-group:first-child > label:first-child) {
  margin-top: 0; /* ptit hack pour virer le margin-top du premier label */
}
@media (max-width: 768px) {
  .profile-content {
    flex-direction: column;
    gap: 1rem;
  }
}
</style>
